<template>
  <d-modal v-if="showModal" size="lg">
    <d-modal-header :close="false" :loading="loading">
      <d-modal-title>Editing Collection</d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-tabs>
        <d-tab title="General" active>
          <div class="px-3">
            <odd-label>Name</odd-label>
            <d-input
              v-model="name"
              help="hi"
              :state="validName ? null : false"
            />
            <small v-if="!validName">A name is required</small>
          </div>
          <div class="px-3">
            <odd-label>Description</odd-label>
            <d-textarea v-model="description" class="mb-2" />
          </div>
        </d-tab>
        <d-tab title="Availablility">
          <div class="p-3">
            <odd-label>Status</odd-label>
            <d-form-select v-model="status" :options="statusOptions" />
            <small v-if="!validName">A name is required</small>
          </div>
        </d-tab>
        <d-tab title="Fulfillment">
          <div class="p-3">
            <d-checkbox v-model="custom_fulfillment" name="custom_fulfillment"
              >Use Custom Fulfillment For This Collection?</d-checkbox
            >
            <div v-if="custom_fulfillment">
              <div
                v-if="!!pickup_configurations && !!pickup_configurations.length"
              >
                <div v-for="config in pickup_configurations" :key="config.id">
                  <pickup-configuration-card
                    :value="config"
                    @update="handlePickupConfigurationUpdate"
                    @delete="handlePickupConfigurationDelete"
                  />
                </div>
              </div>
              <div class="d-flex justify-content-around p-1">
                <d-button
                  round
                  size="sm"
                  theme="dark"
                  type="button"
                  @click="handleAddPickupConfiguration"
                >
                  Add Pickup Configuration
                </d-button>
                <!-- <d-button round size="sm" theme="dark">Add Delivery Configuration</d-button>
              <d-button round size="sm" theme="dark">Add Shipping Configuration</d-button> -->
              </div>
            </div>
          </div>
        </d-tab>
        <d-tab title="Products">
          <div class="p-3">
            <d-list-group>
              <d-list-group-item v-for="product in products" :key="product.key">
                <div
                  class="d-flex flex-row justify-content-between align-items-center"
                >
                  <div>{{ product.name }}</div>
                  <!-- <d-button theme="danger" size="sm" round class="ml-auto">
                    <i class="material-icons">clear</i>
                  </d-button> -->
                </div>
              </d-list-group-item>
            </d-list-group>
            <div class="w-100 text-center py-2 small text-light">
              Add products to this collection from the product edit page.
            </div>
          </div>
        </d-tab>
      </d-tabs>

      <div class="d-flex justify-content-end align-items-center pt-3">
        <d-button class="mx-2" theme="light" @click="handleClose">
          Cancel
        </d-button>
        <async-button
          @click="updateProductCollection"
          text="Save"
          loadingText="saving..."
          :loading="saving"
        />
      </div>
    </d-modal-body>
  </d-modal>
</template>

<script>
import OddWizard from "@/components/Wizard/Wizard";
import OddWizardTab from "@/components/Wizard/Tab";
import { quillEditor } from "vue-quill-editor";
import quillDefaultOptions from "@/utils/quillOptions";
import VueDropzone from "@/components/vue2-dropzone/components/vue-dropzone";
import PickupConfigurationCard from "@/components/PickupConfigurationCard";

import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import { normalizeISO } from "../../utils/datetime";
import { generateID } from "@/utils/id";

export default {
  data() {
    return {
      name: "",
      description: "",
      id: null,
      quillOptions: quillDefaultOptions,
      loading: true,
      saving: false,
      validName: true,
      custom_fulfillment: false,
      pickup: false,
      pickup_configurations: [],
      delivery_configurations: [],
      shipping_configurations: [],
      products: [],
      delivery: false,
      shipping: false,
      status: "",
      statusOptions: [
        { value: "draft", text: "Draft" },
        { value: "public", text: "Public" },
        { value: "private", text: "Private" },
        { value: "archived", text: "Archived" }
      ]
    };
  },
  props: {
    editPK: {
      type: String,
      default: null
    }
  },
  computed: {
    showModal() {
      return this.editPK !== null;
    },
    dropzoneOptions() {
      return {
        thumbnailWidth: 150,
        maxFilesize: 0.5
      };
    },
    uses_pickup() {
      return this.$store.getters["settings/uses_pickup"];
    },
    uses_delivery() {
      return this.$store.getters["settings/uses_delivery"];
    },
    uses_shipping() {
      return this.$store.getters["settings/uses_shipping"];
    },
    show_pickup_times() {
      return this.pickup_times.filter(p => p.date === this.active_pickup_date);
    }
  },
  components: {
    OddWizard,
    OddWizardTab,
    quillEditor,
    VueDropzone,
    PickupConfigurationCard
  },
  watch: {
    editPK(value) {
      if (value === null) {
        this.resetForm();
      } else {
        this.loadProductCollection();
      }
    }
  },
  methods: {
    resetForm() {
      this.name = "";
      this.saving = false;
    },
    loadProductCollection() {
      this.$store
        .dispatch("productCollections/get", this.editPK)
        .then(value => {
          const base_url =
            process.env.NODE_ENV === "development"
              ? "http://localhost:8000"
              : "";
          this.loading = false;
          this.name = value.name;
          this.description = value.description;
          this.status = value.status;
          this.custom_fulfillment = value.custom_fulfillment;
          this.pickup_configurations = value.pickup_configurations;
          this.products = value.products;
        });
    },
    handleAddPickupConfiguration() {
      const new_config = {
        id: generateID(),
        location: "",
        address: "",
        city: "",
        state: null,
        postal: "",
        fee: 0,
        pickup_dates: [],
        pickup_times: []
      };
      if (!!this.pickup_configurations) {
        this.pickup_configurations = [
          ...this.pickup_configurations,
          new_config
        ];
      } else {
        this.pickup_configurations = [new_config];
      }
    },
    handlePickupConfigurationUpdate(value) {
      this.pickup_configurations = this.pickup_configurations.map(config => {
        return config.id === value.id ? value : config;
      });
    },
    handlePickupConfigurationDelete(id) {
      this.pickup_configurations = this.pickup_configurations.filter(config => {
        config.id !== id;
      });
    },
    handleClose(event) {
      this.$emit("close", event);
    },
    validateName() {
      this.validName = 3 < this.name.length && this.name.length < 100;
    },
    validate() {
      this.validateName();
      return this.validName;
    },
    updateProductCollection() {
      if (this.validate()) {
        this.saving = true;
        const productCollection = {
          id: this.editPK,
          name: this.name,
          description: this.description,
          status: this.status,
          custom_fulfillment: this.custom_fulfillment,
          pickup_configurations: this.pickup_configurations
        };
        this.$store
          .dispatch("productCollections/update", productCollection)
          .then(result => {
            this.saving = false;
            this.$emit("dataUpdated");
            this.handleClose();
          });
      }
    }
  }
};
</script>

<style></style>
